import lozad from "lozad";

window.observer = lozad(".lozad", {
  threshold: 0.1,
  rootMargin: "50% 150% 50% 150%",
  enableAutoReload: true,
  load: async function (el) {
    // Simple img-tag
    if (el.hasAttribute("lozad-img")) {
      el.setAttribute("src", el.getAttribute("data-src"));
      el.removeAttribute("data-src");
      return;
    }

    // Lazy section
    if (el.hasAttribute("lozad-section")) {
      const response = await fetch(el.getAttribute("data-lazy-src"));
      const json = await response.json();

      if (json.success) {
        el.innerHTML = json.data;
      }

      el.removeAttribute("data-lazy-src");

      if (el.hasAttribute("data-loaded-event")) {
        window.dispatchEvent(new CustomEvent(el.getAttribute("data-loaded-event")));
      }
      return;
    }
  },
});

window.observer.observe();
